// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__4s6Ha"};